module.exports = __webpack_public_path__ + "public/images/drawing.571872a3282099130c64eaaabd2b89cf.png";